// extracted by mini-css-extract-plugin
export default {"main":"MainAbout_main__LxTQp","content":"MainAbout_content__tBwes","blue":"MainAbout_blue__St8c3","blueLink":"MainAbout_blueLink__3JsSR","imgcont":"MainAbout_imgcont__XsLK8"};